const initComponent = (Component, selector, parent = document) => {
  const elements = parent.querySelectorAll(`[data-module="${selector}"]`)

  elements.forEach(element => {
    element.removeAttribute('data-module')
    Component(element)
  })
}

export {
  initComponent
}
